export default "dist/images/components-columns-width-control-4-3-uneven.9b00d6b.png";